import { render, staticRenderFns } from "./SPHumanResources.vue?vue&type=template&id=3be3fbdc&"
import script from "./SPHumanResources.vue?vue&type=script&lang=js&"
export * from "./SPHumanResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports